import styled, { css, keyframes } from "styled-components";
import checkboxChecked from "../../../images/checkbox-small-checked.svg";
import greenCheckMark from "../routes/assets/add-ons/green-checkmark.svg";
import BaseButton from "../../common/Button";

export const brainTreeFormStyles = {
  input: {
    "font-family": "Circular, sans-serif",
    "font-size": "15px",
    "font-weight": "normal",
    transition: "color 0.1s",
    color: "#576474"
  },
  "::placeholder": {
    color: "#C4C8D0",
    "font-weight": "normal"
  }
};

export const inputStyles = css`
  width: 100%;
  height: 42px;
  padding: 0 11px;
  border: 2px solid #c5c9d1;
  border-radius: 4px;
  overflow: hidden;
  background-color: white;
  font-family: "Circular", sans-serif;
  font-size: 15px;
  font-weight: normal;
  transition: color 0.1s;
  color: #576474;
  outline: none;
  &::placeholder {
    color: #c4c8d0;
  }
`;

const scaleAndFadeIn = keyframes`
  from {
    transform: scale(0.5);
    opacity: 0;
  } 
  to {
    transform: scale(1);
    opacity: 1;
  }
`;

export const FormFieldGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 -10px;
`;

export const FormFieldWrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  margin: 0 0 10px 0;
  flex: 1 1 auto;
  @media (max-width: 768px) {
    margin: 0 0 20px;
  }
  .braintree-hosted-field {
    ${inputStyles};
  }
  .braintree-hosted-fields-valid {
    position: relative;
    &::after {
      content: url(${greenCheckMark});
      position: absolute;
      right: 8px;
      top: 8px;
      font-size: 18px;
      color: #2dc878;
      animation: ${scaleAndFadeIn} 200ms ease-out;
    }
  }
  .braintree-hosted-fields-invalid {
    border: 2px solid #e53a40;
  }
  input {
    ${inputStyles};
    width: 100%;
    ${({ hasError }) =>
      hasError &&
      css`
        border: 2px solid #e53a40;
      `};
    &.validated {
      &::after {
        content: "check";
        position: absolute;
        right: 8px;
        top: 7px;
        font-family: "Material Icons";
        font-size: 18px;
        color: #2dc878;
        animation: ${scaleAndFadeIn} 200ms ease-out;
      }
    }
  }

  ${FormFieldGroup} & {
    width: 50%;
    padding: 0 10px;
  }
`;

export const Label = styled.label`
  margin: 0 0 8px;

  font-size: 15px;
  font-weight: normal;
  color: #566373;
  letter-spacing: 0;
  line-height: 24px;
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PromoCode = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  input {
    max-width: 215px;
  }
`;

export const ApplyDiscount = styled(BaseButton)`
  flex: 1 1 auto;
  margin-left: 14px;
  padding: 10px 12px;
  min-width: 71px;
`;

export const BillingNotice = styled.p`
  font-size: 14px;
  margin-top: 8px;
`;

export const TOS = styled.div`
  margin: 12px 0 24px;
  -webkit-font-smoothing: antialiased;

  input[type="checkbox"] {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    clip: rect(1px, 1px, 1px, 1px);
    white-space: nowrap; /* added line */
  }

  input[type="checkbox"] + label {
    position: relative;
    display: inline-block;
    padding-left: 28px;
    font-size: 14px;
  }

  input[type="checkbox"] + label::before {
    content: "";
    border: 2px solid ${({ theme }) => theme.colors.gray[600]};
    background-color: white;
    display: inline-block;
    position: absolute;
    top: 3px;
    left: 0;
    width: 14px;
    height: 14px;
    border-radius: 3px;
  }

  input[type="checkbox"]:focus + label::before {
    box-shadow: 0 0 5px 1px #9f39f8;
    border: 2px solid ${({ theme }) => theme.colors.suite[900]};
  }

  input[type="checkbox"]:checked + label::before {
    border: 2px solid ${({ theme }) => theme.colors.suite[900]};
    background-color: ${({ theme }) => theme.colors.suite[900]};
    background-image: url(${checkboxChecked});
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
  }
`;

export const FormSubmit = styled(BaseButton)`
  width: 100%;
  margin-top: 11px;
`;

export const FlashError = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.accent.red};
  border-radius: 3px;
  padding: 8px 16px;
  box-sizing: border-box;
  color: white;
  text-align: center;
  margin-top: 21px;
`;
